import { EmployeeListItemDto } from "./employee";
import { TransportOrderListItemDto } from "./transportOrder";
import { VehicleListItemDto } from "../vehicle/vehicle";
import { TransportPlanDetailsDto, TransportPlanState } from "./transportPlan";

export const enum TransportState {
    Waiting,
    InTransport,
    Completed,
    Failed,
}

export interface TransportDetails {
    id: string;
    startDateTime: string;
    endDateTime: string;
    employee: EmployeeListItemDto;
    vehicle: VehicleListItemDto;
    state: TransportState;
    plan: TransportPlanDetailsDto;
}

export const enum TransportTaskType {
    PickedUp,
    Delivered,
}

export interface TransportListItem {
    id: string;
    startDateTime: string;
    endDateTime: string;
    state: TransportState;
    employee: EmployeeListItemDto;
    vehicle: VehicleListItemDto;
    transportOrders: TransportOrderListItemDto[];
    transportPlan: TransportPlanDetailsDto;
}

export interface TransportOrTransportPlan {
    transportPlanId: string;
    transportId?: string;
    name: string;
    transportPlanState: TransportPlanState;
    transportState?: TransportState;
    employee: EmployeeListItemDto;
    vehicle: VehicleListItemDto;
    orders: TransportOrderListItemDto[];
    plan?: TransportPlanDetailsDto;
    startDateTime?: string;
    endDateTime?: string;
    isPlan: boolean;
}
